/**
 * English Language Pack
 */
export default {
  common: {
    confirm: "Confirm",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    reset: "Reset",
    submit: "Submit",
    back: "Back",
    enable: "Enable",
    disable: "Disable",
    logout: "Logout",
    loading: "Loading...",
    noData: "No Data",
    success: "Success",
    failed: "Failed",
    error: "Error",
    pleaseSelect: "Please Select",
    pleaseInput: "Please Input",
    language: "Language",
    yes: "Yes",
    no: "No",
    show: "Show",
    hide: "Hide",
    refresh: "Refresh",
    actions: "Actions",
    status: "Status",
    createdAt: "Created At",
    updatedAt: "Updated At",
    id: "ID",
    remark: "Remark",
    sort: "Sort",
    startTime: "Start Time",
    endTime: "End Time",
    detail: "Detail",
    view: "View",
    close: "Close",
    minutes: "Minutes",
    createSuccess: "Created successfully",
    updateSuccess: "Updated successfully",
  },
  device: {
    title: "Device",
    searchTitle: "Search Devices",
    listTitle: "Device List",
    loginLog: {
      searchTitle: "Search Login Logs",
      listTitle: "Login Log List",
    },

    fingerprint: "Fingerprint",
    fingerprintHash: "Fingerprint Hash",
    fingerprintPlaceholder: "Enter fingerprint hash",
    firstSeenUserId: "First Seen User",
    userIdPlaceholder: "User ID",
    riskLevel: "Risk Level",
    riskLevelPlaceholder: "Select risk level",
    inBlacklist: "In Blacklist",
    inBlacklistPlaceholder: "Select blacklist status",
    inBlacklistYes: "Yes",
    inBlacklistNo: "No",
    inBlacklistAll: "All",
    deviceType: "Device Type",
    deviceTypePlaceholder: "Select device type",
    os: "OS",
    osPlaceholder: "OS name",

    lastSeenAt: "Last Seen At",
    startTime: "Start Time",
    endTime: "End Time",
    sortBy: "Sort By",
    sortOrder: "Sort",
    sortCreated: "Created Time",
    sortStart: "Start Time",
    sortParticipants: "Participants",
    sortReward: "Reward",
    sortDesc: "Desc",
    sortAsc: "Asc",
    sort: {
      createdAt: "Created Time",
      lastSeen: "Last Seen",
      userCount: "Related Users",
      riskScore: "Risk Score",
    },

    updateRisk: "Update Risk",
    addBlacklist: "Add Blacklist",
    removeBlacklist: "Remove Blacklist",
    batchUpdateRisk: "Batch Risk",
    batchAddBlacklist: "Batch Blacklist",
    risk: {
      low: "Low",
      medium: "Medium",
      high: "High",
      critical: "Critical",
      blocked: "Blocked",
      unknown: "Unknown",
    },
    reason: "Reason",
    reasonPlaceholder: "Please input reason (10-500 chars)",
    reasonMin: "Reason needs at least {min} characters",

    loadFail: "Load failed",
    actionFail: "Action failed",
    blacklistAdded: "Added to blacklist",
    blacklistRemoved: "Removed from blacklist",
    copy: "Copy",
    copySuccess: "Copied",
    copyFail: "Copy failed",
    relatedUserCount: "Related Users",
    riskScore: "Risk Score",
    stats: {
      total: "Total Devices",
      highRisk: "High Risk Devices",
      blacklisted: "Blacklisted",
      multiAccount: "Multi-account",
    },
    type: {
      desktop: "Desktop",
      mobile: "Mobile",
      tablet: "Tablet",
    },
    basicInfo: "Basic Info",
    features: "Device Features",
    osVersion: "OS Version",
    phoneModel: "Phone Model",
    browser: "Browser",
    browserVersion: "Browser Version",
    browserEngine: "Browser Engine",
    language: "Language",
    timezone: "Timezone",
    platform: "Platform",
    screenResolution: "Screen Resolution",
    deviceMemory: "Device Memory(GB)",
    hardwareConcurrency: "CPU Threads",
    colorDepth: "Color Depth",
    pixelRatio: "Pixel Ratio",
    touchSupport: "Touch Support",
    languages: "Languages",
    riskAssessment: "Risk Assessment",
    lastAssessedAt: "Last Assessed",
    ruleDesc: "Description",
    score: "Score",
    triggeredAt: "Triggered At",
    relatedUsers: "Related Users",
    relations: "Relations",
    userId: "User ID",
    relatedIps: "Related IPs",
    loginLogs: "Login Logs",
    loginStatusPlaceholder: "Login status",
    loginTime: "Login Time",

    failureReason: "Failure Reason",
    ipAddress: "IP Address",
    userAgent: "User Agent",
    operationLogs: "Operation Logs",
    operationTypePlaceholder: "Operation type",
    operationType: "Operation Type",
    operationDesc: "Description",
    oldValue: "Old",
    newValue: "New",
    operator: "Operator",
    back: "Back",
    reassess: "Reassess Risk",
    reassessSuccess: "Reassessed",
    noData: "No Data",
    loginStatus: "Login Status",
    lastAssessed: "Last Assessed",
    riskConfig: "Risk Level Config",

    saveSuccess: "Saved",
    restrictions: "Restrictions",
    restrictionsPlaceholder: "JSON restrictions (optional)",
    scoreRange: "Score Range",
    color: "Color",
    typeStats: "Type Stats",
    operatorPlaceholder: "Operator ID",
    operation: {
      riskLevel: "Risk Level Change",
      blacklistAdd: "Add Blacklist",
      blacklistRemove: "Remove Blacklist",
      riskReassess: "Reassess",
    },
    riskRules: "Risk Rules",
    ruleList: "Rule List",
    ruleType: "Rule Type",
    ruleTypeDevice: "Device",
    ruleTypeIp: "IP",
    ruleTypeBehavior: "Behavior",
    ruleName: "Rule Name",
    ruleCode: "Rule Code",
    priority: "Priority",
    triggeredCount: "Triggered",
    parameters: "Parameters",
    parametersPlaceholder: "JSON parameters, leave empty to keep",
    parametersInvalid: "Parameters must be valid JSON",
    editRule: "Edit Rule",
    execute: "Execute",
    executeConfirm: "Execute this rule now?",
    executeSuccess: "Execution triggered",
    isEnabled: "Enabled",
    required: "Required field",
    riskUpdated: "Risk updated",
    viewDetail: "View Detail",
  },
  dateShortcuts: {
    today: "Today",
    last3d: "Last 3 days",
    last7d: "Last 7 days",
    thisMonth: "This month",
    last3m: "Last 3 months",
    startTime: "Start Time",
    endTime: "End Time",
  },
  login: {
    title: "LuckyTask Admin",
    username: "Username",
    password: "Password",
    login: "Login",
    loginSuccess: "Login Success",
    loginFailed: "Login Failed",
    usernameRequired: "Please enter username",
    passwordRequired: "Please enter password",
    rememberMe: "Remember Me",
    verificationRequired: "Please complete verification",
    verificationFailed: "Verification failed",
    verificationExpired: "Verification expired, please retry",
  },
  menu: {
    dashboard: "Dashboard",
    dashboard_index: "Dashboard",
    user: "User",
    user_management: "User Management",
    user_list: "User List",
    user_tags: "User Tags",
    user_addresses: "User Addresses",
    user_invitations: "Invitation Relations",
    task: "Task",
    task_management: "Task Management",
    task_list: "Task List",
    task_detail: "Task Detail",
    task_review: "Task Review",
    wallet: "Wallet",
    wallet_management: "Wallet Management",
    wallet_list: "Wallet List",
    wallet_ledger: "Wallet Ledger",
    device_management: "Device Management",
    device_list: "Device List",
    device_risk_config: "Risk Level Config",
    device_detail: "Device Detail",
    device_login_log: "Login Logs",
    device_risk_rules: "Risk Rules",
    lottery: "Lottery",
    lottery_management: "Lottery Management",
    lottery_list: "Lotteries",
    lottery_plan_list: "Lottery Plans",
    lottery_plan_detail: "Plan Detail",
    lottery_plan_create: "Create Plan",
    lottery_plan_edit: "Edit Plan",
    lottery_pending_draw: "Pending Draw",
    lottery_participation: "Lottery Participation",
    lottery_winner_list: "Winners",
    lottery_winner_detail: "Winner Detail",
    wallet_detail: "Wallet Detail",
    wallet_ledger_detail: "Ledger Detail",
    wallet_recon_runs: "Reconciliation Runs",
    wallet_recon_logs: "Reconciliation Logs",
    redemption: "Redemption",
    redemption_management: "Redemption Management",
    redemption_list: "Order List",
    system: "System",
    system_management: "System Management",
    system_admin: "Admin Management",
    system_role: "Role Management",
    system_menu: "Menu Management",
    system_dept: "Department Management",
    system_post: "Post Management",
    role: "Roles",
    menu: "Menus",
    permission: "Permissions",
    task_assignment: "Task Assignment",
  },
  btn: {
    user: {
      ban: "Ban User",
      unban: "Unban User",
      detail: "User Detail",
    },
    task: {
      create: "Create Task",
      edit: "Edit Task",
      delete: "Delete Task",
      status: "Change Status",
      approve: "Approve Task",
      reject: "Reject Task",
    },
    wallet: {
      adjust: "Adjust Balance",
      freeze: "Freeze Balance",
      unfreeze: "Unfreeze Balance",
      view: "View Wallet",
    },
    wallet_ledger: {
      export: "Export Ledger",
      view: "View Ledger",
    },
    wallet_recon: {
      trigger: "Trigger Reconciliation",
      view: "View Reconciliation",
      resolve: "Resolve Discrepancy",
    },
    lottery: {
      create: "Create Lottery",
      edit: "Edit Lottery",
      delete: "Delete Lottery",
      draw: "Draw Lottery",
      cancel: "Cancel Lottery",
      view: "View Lottery",
      planCreate: "Create Lottery Plan",
      planUpdate: "Edit Lottery Plan",
      planDelete: "Delete Lottery Plan",
      planStatus: "Change Plan Status",
      planLogs: "View Plan Logs",
      winnerReview: "Review Winner",
    },
    redemption: {
      ship: "Ship Order",
      cancel: "Cancel Order",
      export: "Export Orders",
    },
    system_admin: {
      add: "Add Admin",
      edit: "Edit Admin",
      delete: "Delete Admin",
      reset_pwd: "Reset Password",
    },
    system_role: {
      add: "Add Role",
      edit: "Edit Role",
      delete: "Delete Role",
      assign: "Assign Permissions",
    },
    system_menu: {
      add: "Add Menu",
      edit: "Edit Menu",
      delete: "Delete Menu",
    },
    system_dept: {
      add: "Add Department",
      edit: "Edit Department",
      delete: "Delete Department",
    },
  },
  wallet: {
    searchTitle: "Wallet Search",
    listTitle: "Wallet List",
    userId: "User ID",
    userIdPlaceholder: "Enter user ID",
    nickname: "Nickname",
    nicknamePlaceholder: "Enter nickname",
    phone: "Phone",
    phonePlaceholder: "Enter phone",
    balanceRange: "Balance Range",
    frozenRange: "Frozen Balance Range",
    totalEarnedRange: "Total Earned Range",
    totalSpentRange: "Total Spent Range",
    min: "Min",
    max: "Max",
    registerRange: "Register Range",
    startTime: "Start Time",
    endTime: "End Time",
    sortBy: "Sort By",
    sortOrder: "Order",
    sortDesc: "Desc",
    sortAsc: "Asc",
    sort: {
      balance: "Balance",
      frozen: "Frozen Balance",
      totalEarned: "Total Earned",
      totalSpent: "Total Spent",
      updatedAt: "Updated At",
    },
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    balance: "Balance",
    frozenBalance: "Frozen Balance",
    availableBalance: "Available",
    totalEarned: "Total Earned",
    totalSpent: "Total Spent",
    updatedAt: "Updated At",
    actions: "Actions",
    viewDetail: "Detail",
    viewLedger: "Ledger",
    adjust: "Adjust",
    adjustTitle: "Adjust Balance",
    adjustType: "Adjust Type",
    adjustTypeAdd: "Add",
    adjustTypeDeduct: "Deduct",
    amount: "Amount",
    reason: "Reason",
    remark: "Remark",
    adjustReasonPlaceholder: "Enter reason (min 10 chars)",
    remarkPlaceholder: "Remark (optional)",
    adjustPreview: "Estimated balance after operation: {value}",
    missingUserId: "Missing user ID",
    adjustSuccess: "Balance adjusted",
    adjustFail: "Adjust failed",
    freeze: "Freeze",
    freezeTitle: "Freeze Coins",
    freezeReasonPlaceholder: "Enter reason (min 10 chars)",
    freezeHint: "Available: {balance}, Frozen: {frozen}",
    freezeSuccess: "Frozen successfully",
    unfreeze: "Unfreeze",
    unfreezeTitle: "Unfreeze Coins",
    unfreezeHint: "Frozen: {frozen}",
    unfreezeSuccess: "Unfrozen successfully",
    actionFail: "Operation failed",
    overview: "Wallet Overview",
    version: "Version",
    registerTime: "Register Time",
    balanceTrend: "Balance Trend (Last 30 days)",
    date: "Date",
    transactionStats: "Transaction Type Stats",
    incomeStats: "Income",
    expenseStats: "Expense",
    type: "Type",
    count: "Count",
    amountLabel: "Amount",
    stats: {
      totalUsers: "Total Wallet Users",
      platformTotalBalance: "Platform Balance",
      platformTotalFrozen: "Platform Frozen",
      todayNewBalance: "Today Added Balance",
    },
    loadFail: "Load failed",
  },
  walletLedger: {
    searchTitle: "Ledger Search",
    listTitle: "Ledger List",
    userId: "User ID",
    userIdPlaceholder: "Enter user ID",
    nickname: "Nickname",
    nicknamePlaceholder: "Enter nickname",
    timeRange: "Time Range",
    startTime: "Start Time",
    endTime: "End Time",
    timeRequired: "Please select time range",
    transactionType: "Transaction Type",
    transactionMap: {
      task_reward: "Task Reward",
      invite_reward: "Invite Reward",
      lottery_entry: "Lottery Entry",
      lottery_refund: "Lottery Refund",
      manual_adjust: "Manual Adjust",
      promo_bonus: "Promo Bonus",
      reconciliation: "Reconciliation",
      redeem_cost: "Redeem Cost",
      unknown: "Unknown",
    },
    amount: "Amount",
    amountRange: "Amount Range",
    amountType: "Amount Type",
    amountIncome: "Income",
    amountExpense: "Expense",
    relatedEntity: "Related Entity",
    relatedPlaceholder: "Enter related entity",
    idempotencyKey: "Idempotency",
    idempotencyPlaceholder: "Enter idempotency key",
    sortBy: "Sort By",
    sortOrder: "Order",
    sortDesc: "Desc",
    sortAsc: "Asc",
    sort: {
      createdAt: "Created At",
      amount: "Amount",
    },
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    export: "Export",
    checkExport: "Check Export",
    exportTitle: "Create Export Task",
    format: "Format",
    exportCreated: "Export task created: {taskId}",
    exportFail: "Export failed",
    noTask: "No export task yet",
    exportReady: "Export ready, downloading...",
    exportStatus: "Task status: {status}",
    loadFail: "Load failed",
    id: "Ledger ID",
    balanceAfter: "Balance After",
    balanceBefore: "Balance Before",
    remark: "Remark",
    createdAt: "Created At",
    actions: "Actions",
    viewDetail: "Detail",
    detailTitle: "Ledger Detail",
    invalidId: "Invalid ledger ID",
    stats: {
      totalCount: "Total Count",
      totalIncome: "Total Income",
      totalExpense: "Total Expense",
      netChange: "Net Change",
    },
    max: "Max",
    min: "Min",
    related: "Related",
  },
  walletRecon: {
    runSearchTitle: "Reconciliation Run Search",
    runListTitle: "Reconciliation Runs",
    status: "Status",
    source: "Source",
    sourceMap: {
      manual: "Manual",
      cron: "Cron",
      api: "API",
    },
    statusMap: {
      scheduled: "Scheduled",
      running: "Running",
      completed: "Completed",
      failed: "Failed",
    },
    hasDiscrepancy: "Has Discrepancy",
    yes: "Yes",
    no: "No",
    startedRange: "Started Range",
    startTime: "Start Time",
    endTime: "End Time",
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    runId: "Run ID",
    runIdPlaceholder: "Enter run ID",
    range: "Range",
    discrepancyCount: "Diff Count",
    duration: "Duration",
    startedAt: "Started At",
    finishedAt: "Finished At",
    actions: "Actions",
    viewDetail: "Detail",
    trigger: "Trigger Reconciliation",
    triggerTitle: "Start Reconciliation",
    reconciliationType: "Type",
    type: {
      incremental: "Incremental",
      full: "Full",
    },
    rangeOptional: "Range (optional)",
    triggerSuccess: "Task created",
    triggerFail: "Task creation failed",
    loadFail: "Load failed",
    runDetailTitle: "Run Detail",
    isIncremental: "Incremental",
    createdBy: "Created By",
    errorMessage: "Error Message",
    statistics: "Statistics",
    checkedUsers: "Checked Users",
    totalDiff: "Total Diff",
    resultSnapshot: "Result Snapshot",
    noSnapshot: "No snapshot",
    viewLogs: "View Logs",
    logSearchTitle: "Discrepancy Log Search",
    logListTitle: "Discrepancy Logs",
    logId: "Log ID",
    user: "User",
    userId: "User ID",
    userIdPlaceholder: "Enter user ID",
    diff: "Diff",
    diffRange: "Diff Range",
    min: "Min",
    max: "Max",
    detectedAt: "Detected At",
    resolutionNote: "Resolution Note",
    resolve: "Resolve",
    resolveTitle: "Handle Discrepancy",
    action: "Action",
    actionResolved: "Mark Resolved",
    actionIgnored: "Mark Ignored",
    actionAdjust: "Adjust Balance",
    note: "Note",
    notePlaceholder: "Enter note (min 10 chars)",
    resolveSuccess: "Resolved",
    resolveFail: "Resolve failed",
    statusLog: {
      unresolved: "Unresolved",
      resolved: "Resolved",
      ignored: "Ignored",
    },
    walletBalance: "Wallet",
    ledgerTotal: "Ledger",
    balance: "Balance",
    invalidId: "Invalid ID",
  },
  lotteryPlan: {
    searchTitle: "Lottery Plan Search",
    keyword: "Keyword",
    keywordPlaceholder: "Plan name keyword",
    status: "Status",
    statusPlaceholder: "Select status",
    triggerType: "Trigger Type",
    triggerTypePlaceholder: "Select trigger type",
    triggerTypeMap: {
      interval: "Interval",
      on_full: "On Full",
      unknown: "Unknown",
    },
    createdRange: "Created At",
    startTime: "Start Time",
    endTime: "End Time",
    startTimePlaceholder: "Select start time",
    endTimePlaceholder: "Select end time",
    createdAt: "Created At",
    sortBy: "Sort By",
    sortByPlaceholder: "Select sort field",
    sortOrder: "Order",
    sortDesc: "Desc",
    sortAsc: "Asc",
    sort: {
      createdAt: "Created At",
      startTime: "Start Time",
      endTime: "End Time",
    },
    search: "Search",
    reset: "Reset",
    create: "Create Plan",
    createTitle: "Create Lottery Plan",
    editTitle: "Edit Lottery Plan",
    detailTitle: "Plan Detail",
    basicInfo: "Basic Info",
    save: "Save",
    refresh: "Refresh",
    planId: "Plan ID",
    planName: "Plan Name",
    planNamePlaceholder: "Enter plan name",
    planDescription: "Description",
    planDescriptionPlaceholder: "Enter plan description",
    coinPerEntry: "Coins Per Entry",
    targetEntries: "Target Entries",
    countdownSeconds: "Countdown (s)",
    maxEntriesPerUser: "Max Entries/User",
    createdCount: "Created/Limit",
    unlimited: "Unlimited",
    actions: "Actions",
    viewDetail: "View Detail",
    edit: "Edit",
    activate: "Activate",
    pause: "Pause",
    resume: "Resume",
    cancel: "Cancel",
    delete: "Delete",
    deleteConfirm: 'Delete plan "{name}"?',
    confirmTitle: "Confirm",
    confirm: "Confirm",
    statusConfirm: 'Switch plan "{name}" to "{status}"?',
    statusSuccess: "Status updated",
    statusFail: "Status update failed",
    deleteSuccess: "Deleted",
    deleteFail: "Delete failed",
    loadFail: "Load failed, please retry",
    submitFail: "Submit failed, please retry",
    createSuccess: "Created successfully",
    updateSuccess: "Updated successfully",
    editLocked: "Plan cannot be edited in current status",
    planNameRequired: "Please enter plan name",
    triggerTypeRequired: "Please select trigger type",
    intervalRequired: "Please enter interval minutes",
    maxWaitRequired: "Please enter max wait seconds",
    minParticipationRequired:
      "Please enter min participation rate between 0 and 1",
    prizeSection: "Prize Config",
    prizeName: "Prize Name",
    prizeNamePlaceholder: "Enter prize name",
    prizeNameRequired: "Please enter prize name",
    prizeType: "Prize Type",
    prizeTypeRequired: "Please select prize type",
    prizeTypeMap: {
      physical: "Physical",
      voucher: "Voucher",
      topup: "Top-up",
    },
    prizeCategory: "Prize Category",
    prizeCategoryPlaceholder: "Enter prize category",
    prizeCategoryRequired: "Please enter prize category",
    prizeValueUsd: "Prize Value (USD)",
    prizeValueRequired: "Please enter prize value",
    deliveryType: "Delivery Type",
    deliveryTypePlaceholder: "Enter delivery type (shipping/digital)",
    deliveryTypeRequired: "Please enter delivery type",
    estimatedDeliveryDays: "Estimated Delivery Days",
    estimatedDeliveryDaysPlaceholder: "Enter estimated delivery days",
    estimatedDeliveryDaysRequired: "Please enter estimated delivery days",
    estimatedDeliveryDaysInvalid: "Estimated delivery days must be >= 0",
    prizeImages: "Prize Images",
    prizeImagesPlaceholder: "Enter image URL and press Enter",
    prizeImagesRequired: "Please provide at least one image URL",
    prizeDescription: "Prize Description",
    prizeDescriptionPlaceholder: "Enter prize description",
    paramsSection: "Parameters",
    lifecycle: "Lifecycle",
    intervalMinutes: "Interval Minutes",
    maxWaitSeconds: "Max Wait Seconds",
    minParticipationRate: "Min Participation Rate",
    allowPreCreate: "Allow Pre-create",
    preCreateCount: "Pre-create Count",
    preCreateRequired: "Please enter pre-create count",
    maxLotteryCount: "Max Lottery Count",
    statusMap: {
      draft: "Draft",
      active: "Active",
      paused: "Paused",
      cancelled: "Cancelled",
      completed: "Completed",
      unknown: "Unknown",
    },
    startTimeRequired: "Please select start time",
    coinRequired: "Please enter coins per entry",
    targetEntriesRequired: "Please enter target entries",
    countdownRequired: "Countdown must be at least 60 seconds",
    invalidId: "Missing plan ID",
    updatedAt: "Updated At",
    viewImage: "View Image",
    executionLogs: "Execution Logs",
    logStatusPlaceholder: "Filter by status",
    logId: "Log ID",
    logLotteryId: "Lottery ID",
    logStatus: {
      label: "Status",
      success: "Success",
      failed: "Failed",
      unknown: "Unknown",
    },
    logError: "Error Message",
    logCreatedAt: "Executed At",
    logLoadFail: "Failed to load execution logs",
    createdRangePlaceholder: "Select created time",
    editSuccess: "Edited successfully",
    listTitle: "Lottery Plan List",
    sortOrderPlaceholder: "Select sort order",
  },
  lottery: {
    searchTitle: "Lottery Search",
    keyword: "Keyword",
    keywordPlaceholder: "Lottery number / prize name",
    planId: "Plan ID",
    planIdPlaceholder: "Enter plan ID",
    status: "Status",
    statusPlaceholder: "Select status",
    prizeType: "Prize Type",
    prizeTypePlaceholder: "Select prize type",
    prizeTypeMap: {
      physical: "Physical",
      voucher: "Voucher",
      topup: "Top-up",
    },
    startRange: "Start Time",
    drawRange: "Draw Time",
    drawStart: "Draw start",
    drawEnd: "Draw end",
    sortBy: "Sort By",
    sortOrder: "Order",
    sortDesc: "Desc",
    sortAsc: "Asc",
    sort: {
      createdAt: "Created At",
      startTime: "Start Time",
      drawTime: "Draw Time",
    },
    search: "Search",
    reset: "Reset",
    create: "Create Lottery",
    idPlaceholder: "Enter lottery ID",
    idInvalid: "Please enter a valid lottery ID",
    createTitle: "Create Lottery",
    viewDetail: "View Detail",
    refresh: "Refresh",
    id: "Lottery ID",
    lotteryNumber: "Lottery Number",
    planName: "Plan",
    prizeName: "Prize Name",
    prizeNamePlaceholder: "Enter prize name",
    prizeNameRequired: "Please enter prize name",
    prizeValueCoins: "Prize Value (coins)",
    prizeValueRequired: "Please enter prize value",
    prizeImage: "Prize Image",
    winnerEntryId: "Winner Entry ID",
    winnerUserId: "Winner User ID",
    prizeImagePlaceholder: "Enter image URL",
    prizeImageRequired: "Please provide prize image URL",
    prizeDescription: "Prize Description",
    prizeDescriptionPlaceholder: "Enter prize description",
    coinPerEntry: "Coins Per Entry",
    coinRequired: "Please enter coins per entry",
    targetEntries: "Target Entries",
    targetEntriesRequired: "Please enter target entries",
    countdownSeconds: "Countdown (s)",
    countdownRequired: "Countdown must be >= 60s",
    maxEntriesPerUser: "Max Entries/User",
    startTime: "Start Time",
    startTimePlaceholder: "Select start time",
    endTime: "End Time",
    endTimePlaceholder: "Select end time",
    drawTime: "Draw Time",
    createdAt: "Created At",
    updatedAt: "Updated At",
    statusMap: {
      upcoming: "Upcoming",
      active: "Active",
      full: "Full",
      drawn: "Drawn",
      cancelled: "Cancelled",
      unknown: "Unknown",
    },
    progress: "Progress",
    actions: "Actions",
    cancel: "Cancel Lottery",
    cancelSuccess: "Cancelled successfully",
    autoDrawOnFull: "Auto draw when full",
    listTitle: "Lottery List",
    prizeTypeRequired: "Please select prize type",
    startTimeRequired: "Please select start time",
    cancelFail: "Cancel failed",
    cancelReasonPlaceholder: "Please enter reason (min 10 chars)",
    cancelReasonMin: "Reason must be at least {min} characters",
    confirm: "Confirm",
    cancelText: "Cancel",
    detailTitle: "Lottery Detail",
    activeTickets: "Active Tickets",
    loadFail: "Load failed, please retry",
    detailFail: "Failed to get detail",
    createSuccess: "Created successfully",
    createFail: "Create failed",
  },
  lotteryWinner: {
    searchTitle: "Winner Search",
    listTitle: "Winner List",
    lotteryId: "Lottery ID",
    lotteryIdPlaceholder: "Enter lottery ID",
    userId: "User ID",
    userIdPlaceholder: "Enter user ID",
    claimStatus: "Claim Status",
    claimStatusMap: {
      pending_review: "Pending Review",
      pending_kyc: "Pending KYC",
      pending_shipment: "Pending Shipment",
      pending_grant: "Pending Grant",
      shipped: "Shipped",
      granted: "Granted",
      completed: "Completed",
      cancelled: "Cancelled",
      rejected: "Rejected",
      unknown: "Unknown",
    },
    riskLevel: "Risk Level",
    risk: {
      low: "Low",
      medium: "Medium",
      high: "High",
    },
    kycRequired: "KYC Required",
    kycStatus: "KYC Status",
    kycDone: "Completed",
    kycPending: "Pending",
    createdRange: "Win Time",
    startTime: "Start Time",
    endTime: "End Time",
    sortBy: "Sort By",
    sortOrder: "Order",
    sortDesc: "Desc",
    sortAsc: "Asc",
    sort: {
      createdAt: "Created At",
    },
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    viewDetail: "View Detail",
    id: "Winner ID",
    lotteryNumber: "Lottery Number",
    prizeName: "Prize Name",
    prizeType: "Prize Type",
    prizeValueCoins: "Prize Value",
    status: "Claim Status",
    createdAt: "Win Time",
    updatedAt: "Updated At",
    loadFail: "Load failed, please retry",
    detailFail: "Failed to get detail",
    detailTitle: "Winner Detail",
    review: "Review",
    reviewTitle: "Risk Review",
    reviewResult: "Result",
    reviewApproved: "Approved",
    reviewRejected: "Rejected",
    reviewNotes: "Notes",
    reviewNotesPlaceholder: "Enter review notes (min 10 chars)",
    reviewSuccess: "Review completed",
    reviewFail: "Review failed",
    reviewLogs: "Review Logs",
    logId: "Log ID",
    reviewType: "Review Type",
    reviewer: "Reviewer",
    reviewTime: "Review Time",
    actions: "Actions",
  },
  lotteryEntry: {
    searchTitle: "Entry Search",
    listTitle: "Entry List",
    lotteryId: "Lottery ID",
    lotteryIdPlaceholder: "Enter lottery ID",
    lotteryIdRequired: "Please enter a valid lottery ID",
    lotteryNumber: "Lottery Number",
    userId: "User ID",
    userIdPlaceholder: "Enter user ID",
    userIdRequired: "Please enter a valid user ID",
    ticketRange: "Ticket Range",
    ticketCount: "Ticket Count",
    coinsSpent: "Coins Spent",
    status: "Status",
    statusMap: {
      active: "Active",
      refunded: "Refunded",
      drawn: "Drawn",
      winner: "Winner",
      loser: "Loser",
      expired: "Expired",
      unknown: "Unknown",
    },
    createdRange: "Created At",
    startTime: "Start Time",
    endTime: "End Time",
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    id: "Entry ID",
    createdAt: "Created At",
    loadFail: "Load failed, please retry",
  },
  lotteryDraw: {
    searchTitle: "Pending Draw Search",
    listTitle: "Pending Draw List",
    planId: "Plan ID",
    planIdPlaceholder: "Enter plan ID",
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    manualDraw: "Manual Draw",
    confirmTitle: "Confirm",
    confirm: "Confirm",
    cancel: "Cancel",
    confirmDraw: 'Confirm to draw "{number}" now?',
    resultTitle: "Draw Result",
    winnerUser: "Winner User ID",
    ticketIndex: "Winning Ticket",
    drawTime: "Draw Time",
    loadFail: "Failed to load pending list",
    drawSuccess: "Manual draw success",
    drawFail: "Manual draw failed",
  },
  tabs: {
    refresh: "Refresh",
    close: "Close Current",
    closeOthers: "Close Others",
    closeAll: "Close All",
  },
  permission: {
    noPermission: "No Permission",
    accessDenied: "Access Denied",
  },
  dashboard: {
    welcome: "Welcome back",
    subtitle: "Have a great day at work",
    totalUsers: "Total Users",
    activeUsers: "Active Users",
    pendingTasks: "Pending Tasks",
    revenue: "Revenue",
    quickActions: "Quick Actions",
    addUser: "Add User",
    createTask: "Create Task",
    viewReports: "View Reports",
    systemSettings: "System Settings",
    recentActivities: "Recent Activities",
  },
  iframe: {
    noSrc: "No iframe source configured",
  },
  post: {
    title: "Post Management",

    addChild: "Add Child Post",

    code: "Post Code",
    codePlaceholder: "Enter post code",
    name: "Post Name",
    namePlaceholder: "Enter post name",

    remarkPlaceholder: "Enter remark",

    statusAll: "All",
    statusEnable: "Enabled",
    statusDisable: "Disabled",

    addTitle: "Add Post",
    editTitle: "Edit Post",

    loadFail: "Failed to load posts",
    detailFail: "Failed to fetch post detail",
    submitFail: "Submit failed, please retry",
    createSuccess: "Created successfully",
    updateSuccess: "Updated successfully",
    deleteSuccess: "Deleted successfully",
    deleteConfirmPrefix: 'Confirm delete post "',
    deleteConfirmSuffix: '"?',
    confirmTitle: "Notice",
    listTitle: "Post List",
  },
  dept: {
    title: "Department Management",

    addChild: "Add Child Dept",

    name: "Department Name",
    namePlaceholder: "Enter department name",
    code: "Department Code",
    codePlaceholder: "Enter unique code",
    // 合并后的提示文案
    codeExists: "Code already exists, please use another",
    leader: "Leader",
    leaderPlaceholder: "Enter leader",
    phone: "Phone",
    phonePlaceholder: "Enter phone",
    email: "Email",
    emailPlaceholder: "Enter email",

    statusAll: "All",
    statusEnable: "Enabled",
    statusDisable: "Disabled",

    addTitle: "Add Department",
    editTitle: "Edit Department",
    parent: "Parent Dept",
    parentPlaceholder: "Select parent",
    type: "Type",
    typePlaceholder: "Select type",
    typeCompany: "Company",
    typeDepartment: "Department",
    typeGroup: "Group",

    loadFail: "Failed to load departments",
    detailFail: "Failed to fetch department detail",
    submitFail: "Submit failed, please retry",
    createSuccess: "Created successfully",
    updateSuccess: "Updated successfully",
    deleteSuccess: "Deleted successfully",
    deleteConfirmPrefix: 'Confirm delete department "',
    deleteConfirmSuffix: '"?',
    confirmTitle: "Notice",
  },
  role: {
    title: "Role Management",

    code: "Role Code",
    codePlaceholder: "Enter role code",
    name: "Role Name",
    namePlaceholder: "Enter role name",

    remarkPlaceholder: "Enter remark",

    statusAll: "All",
    statusEnable: "Enabled",
    statusDisable: "Disabled",
    // Data scope（两段合并，保留 Unknown）
    dataScope: "Data Scope",
    dataScopePlaceholder: "Select data scope",
    dataScopeAll: "All data",
    dataScopeCustom: "Custom data",
    dataScopeDept: "Current dept",
    dataScopeDeptAndBelow: "Dept and below",
    dataScopeSelf: "Self only",
    dataScopeUnknown: "Unknown",

    menuPerm: "Menu Permissions",
    menuPermFor: "Edit role menu permissions",
    menuLoadFail: "Failed to load menus",
    collapseAll: "Collapse All",
    expandAll: "Expand All",
    checkAll: "Select All",
    uncheckAll: "Clear All",

    addTitle: "Add Role",
    editTitle: "Edit Role",

    loadFail: "Failed to load roles",
    detailFail: "Failed to fetch role detail",
    submitFail: "Submit failed, please retry",
    createSuccess: "Created successfully",
    updateSuccess: "Updated successfully",
    deleteSuccess: "Deleted successfully",
    deleteConfirmPrefix: 'Confirm delete role "',
    deleteConfirmSuffix: '"?',
    confirmTitle: "Notice",
    parent: "Parent Role",
    parentPlaceholder: "Select parent role",
    parentRoot: "Root",
    // 二段中的新增字段
    dataPerm: "Data Scope",
    dataPermFor: "Edit role data scope",
    customDept: "Custom Departments",
  },
  adminUser: {
    title: "Admin Management",
    add: "Add Admin",
    refresh: "Refresh",
    search: "Search",
    reset: "Reset",
    id: "ID",
    username: "Username",
    usernamePlaceholder: "Enter username",
    realName: "Real Name",
    realNamePlaceholder: "Enter real name",
    status: "Status",
    statusPlaceholder: "Select status",
    statusEnable: "Active",
    statusDisable: "Disabled",
    statusLocked: "Locked",
    statusAll: "All",
    sex: "Gender",
    sexPlaceholder: "Select gender",
    sexUnknown: "Unknown",
    sexMale: "Male",
    sexFemale: "Female",
    dept: "Department",
    deptPlaceholder: "Select department",
    role: "Role",
    rolePlaceholder: "Select role",
    mobile: "Mobile",
    mobilePlaceholder: "Enter mobile",
    email: "Email",
    emailPlaceholder: "Enter email",
    telegram: "Telegram",
    telegramPlaceholder: "Enter telegram",
    remark: "Remark",
    remarkPlaceholder: "Enter remark",
    password: "Password",
    newPassword: "New Password",
    passwordPlaceholder: "Enter password",
    resetPassword: "Reset Password",
    lastLoginAt: "Last Login",
    enable: "Enable",
    disable: "Disable",
    delete: "Delete",
    edit: "Edit",
    actions: "Actions",
    addTitle: "Add Admin",
    editTitle: "Edit Admin",
    confirm: "Confirm",
    cancel: "Cancel",
    loadFail: "Failed to load admins",
    detailFail: "Failed to fetch detail",
    submitFail: "Submit failed, please retry",
    createSuccess: "Created successfully",
    updateSuccess: "Updated successfully",
    deleteSuccess: "Deleted successfully",
    deleteConfirmPrefix: 'Confirm delete admin "',
    deleteConfirmSuffix: '"?',
    confirmTitle: "Notice",
    listTitle: "Admin User List",
  },
  user: {
    title: "User Management",
    id: "ID",
    userId: "User ID",
    userIdPlaceholder: "Enter user ID",
    phone: "Phone",
    phonePlaceholder: "Enter phone",
    nickname: "Nickname",
    nicknamePlaceholder: "Enter nickname",
    referralCode: "Referral Code",
    referralCodePlaceholder: "Enter referral code",
    ipAddress: "Register IP",
    ipPlaceholder: "Enter IP",
    lastLoginIp: "Last Login IP",
    registerRegion: "Register Region",
    lastLoginRegion: "Last Login Region",
    tagPlaceholder: "Select tags",

    statusPlaceholder: "Select status",
    statusActive: "Active",
    statusBanned: "Banned",
    statusPending: "Pending KYC",
    statusSuspended: "Suspended",
    statusAll: "All",
    riskLevel: "Risk Level",
    riskLevelPlaceholder: "Select risk level",
    riskLow: "Low",
    riskMedium: "Medium",
    riskHigh: "High",
    riskBlocked: "Blocked",
    preferredLanguage: "Lang",
    timezone: "Timezone",
    email: "Email",
    authProviders: "Auth Providers",
    provider: "Provider",
    providerUserId: "Provider User ID",
    linkedAt: "Linked At",
    deviceInfo: "Device Info",
    fingerprint: "Device Fingerprint",
    lastSeen: "Last Seen",
    deviceRisk: "Device Risk",
    firstSeenUserId: "First Seen User",
    deviceMeta: "Device Meta",
    userAgent: "User Agent",
    deviceModel: "Device Model",
    osVersion: "OS Version",
    browserVersion: "Browser",
    inviter: "Inviter",
    invitedBy: "Invited By",
    deviceRiskLevel: "Risk Level",
    empty: "No Data",
    registerRange: "Register Time",
    startTime: "Start time",
    endTime: "End time",
    sortBy: "Sort By",
    sortOrder: "Sort Order",
    sortRegister: "Register time",
    sortLogin: "Last login",
    sortWallet: "Wallet balance",
    sortInvite: "Invitation count",
    sortAsc: "Asc",
    sortDesc: "Desc",
    walletBalance: "Wallet",
    walletFrozen: "Frozen Balance",
    walletTotalEarned: "Total Earned",
    walletTotalSpent: "Total Spent",
    invitationCount: "Invitations",
    tags: "Tags",
    registerTime: "Register Time",
    lastLoginTime: "Last Login",

    export: "Export",
    exportCsv: "Export CSV",
    exportExcel: "Export Excel",
    exportSuccess: "Export task submitted",

    changeStatus: "Change Status",
    batchStatus: "Batch Status",
    batchTags: "Batch Tags",

    reason: "Reason",
    reasonPlaceholder: "Enter reason (min 10 chars)",
    reasonMin: "Reason should be at least 10 characters",
    notes: "Notes",
    addNote: "Add Note",
    notePlaceholder: "Enter note (min 10 chars)",
    noteEmpty: "No notes yet",
    copySuccess: "Copied",
    copyFail: "Copy failed",
    updateSuccess: "Updated successfully",
    loadFail: "Failed to load users",
    submitFail: "Submit failed, please retry",

    tasks: "Task Assignments",
    walletLedger: "Wallet Ledger",
    lotteryEntries: "Lottery Entries",
    delete: "Delete",
    detail: "Detail",
    ipAddressPlaceholder: "Enter IP address",
    reset: "Reset",
    search: "Search",
    status: "Status",
  },
  userTags: {
    title: "User Tag Management",
    id: "ID",
    name: "Tag Name",
    color: "Color",
    isSystem: "System Tag",
    system: "System",
    custom: "Custom",
    actions: "Actions",
    create: "New Tag",
    edit: "Edit",
    delete: "Delete",
    createTitle: "Create Tag",
    editTitle: "Edit Tag",
    namePlaceholder: "Enter tag name",
    colorPlaceholder: "Pick a color",
    nameMin: "Name too short",
    loadFail: "Failed to load tags",
    submitFail: "Submit failed",
    createSuccess: "Created successfully",
    updateSuccess: "Updated successfully",
    deleteSuccess: "Deleted successfully",
    deleteConfirm: "Confirm delete this tag?",
    confirmTitle: "Notice",
    confirm: "Confirm",
    cancel: "Cancel",
  },
  userAddress: {
    title: "User Address",
    userId: "User ID",
    userIdPlaceholder: "Enter user ID",
    search: "Search",
    reset: "Reset",
    id: "ID",
    recipientName: "Recipient",
    recipientPhone: "Phone",
    address: "Address",
    isDefault: "Default",
    default: "Default",
    normal: "Normal",
    createdAt: "Created At",
    loadFail: "Failed to load addresses",
  },
  userInvite: {
    title: "Invitation Relations",
    userId: "User ID",
    userIdPlaceholder: "Enter user ID",
    status: "Reward Status",
    statusPlaceholder: "Select status",
    statusPending: "Pending",
    statusGranted: "Granted",
    statusFailed: "Failed",
    invitationId: "Invitation ID",
    invitationIdPlaceholder: "Enter invitation ID",
    inviterUserId: "Inviter ID",
    inviteeUserId: "Invitee ID",
    inviteCode: "Invite Code",
    inviteCodePlaceholder: "Enter invite code",
    createdRange: "Created Time",
    completedRange: "Completed Time",
    createdAt: "Created At",
    completedAt: "Completed At",
    sortBy: "Sort By",
    sortOrder: "Sort Order",
    sortCreated: "Created time",
    sortCompleted: "Completed time",
    sortTasks: "Tasks completed",
    sortAsc: "Asc",
    sortDesc: "Desc",
    statusCompleted: "Completed",
    statusExpired: "Expired",
    statusCancelled: "Cancelled",
    tasksCompletedPlaceholder: "Enter tasks completed",
    inviteRange: "Invite Time",
    rewardRange: "Reward Time",
    startTime: "Start time",
    endTime: "End time",
    invitedUserFilter: "Invited User",
    invitedUserFilterPlaceholder: "Enter invited user ID",
    search: "Search",
    reset: "Reset",
    inviter: "Inviter",
    invitedUsers: "Invited Users",
    rewards: "Rewards",
    totalInvited: "Total Invited",
    totalRewards: "Total Rewards",
    totalCoins: "Total Coins",
    nickname: "Nickname",
    registerTime: "Register Time",
    completedTask: "Completed Tasks",
    tasksCompleted: "Completed Tasks",
    rewardStatus: "Reward Status",
    rewardId: "Reward ID",
    invitedUserId: "Invited User ID",
    invitedUserName: "Invited User Name",
    rewardCoins: "Coins",
    awardedAt: "Awarded At",
    loadFail: "Failed to load invitations",
    inviteeUserIdPlaceholder: "Enter invitee User ID",
    inviterUserIdPlaceholder: "Enter inviter User ID",
    listTitle: "Invitation List",
  },
  task: {
    pageTitle: "Task Management",
    searchTitle: "Search Tasks",
    tabBasic: "Basic",
    tabDescription: "Description",
    tabSteps: "Steps",
    tabProof: "Proof",
    tabQuota: "Quota & Reward",
    tabTime: "Schedule",
    tabPreview: "Preview",
    detailTab: "Detail",
    previewTab: "Preview",
    previewTitle: "Preview",
    id: "Task ID",
    idPlaceholder: "Enter task ID",
    title: "Title",
    titlePlaceholder: "Enter title",
    category: "Category",
    categoryPlaceholder: "Select category",
    taskType: "Task Type",
    taskTypePlaceholder: "Select task type",
    type: {
      watch_ad: "Watch Ad",
      interaction: "Interaction",
      app_download: "App Download",
      invite: "Invite",
      check_in: "Check-in",
    },
    status: "Status",
    statusPlaceholder: "Select status",
    statusMap: {
      draft: "Draft",
      pending_review: "Pending Review",
      active: "Active",
      paused: "Paused",
      closed: "Closed",
      unknown: "Unknown",
    },
    sponsorType: "Sponsor",
    sponsorPlaceholder: "Select sponsor",
    sponsorName: "Brand Name",
    system: "System",
    brand: "Brand",
    createdAt: "Created At",
    startTime: "Start Time",
    endTime: "End Time",
    autoExpireMinutes: "Auto Expire (min)",
    maxDailyCompletions: "Daily Limit",
    quotaTotal: "Total Quota",
    startEndRange: "Online Time",
    rewardCoins: "Reward (Coins)",
    verificationMode: "Verification",
    verificationAuto: "Auto",
    verificationManual: "Manual",
    verificationCallback: "Callback",
    quota: "Quota",
    unlimited: "Unlimited",
    participants: "Participants",
    createdBy: "Created By",
    actions: "Actions",
    search: "Search",
    reset: "Reset",
    refresh: "Refresh",
    sortBy: "Sort By",
    sortOrder: "Sort Order",
    sortCreated: "Created Time",
    sortStart: "Start Time",
    sortParticipants: "Participants",
    sortReward: "Reward",
    sortAsc: "Asc",
    sortDesc: "Desc",
    create: "Create Task",
    batchPublish: "Batch Publish",
    batchPause: "Batch Pause",
    batchDelete: "Batch Delete",
    view: "View",
    edit: "Edit",
    copy: "Copy",
    delete: "Delete",
    publish: "Publish",
    pause: "Pause",
    resume: "Resume",
    viewDetail: "Task Detail",
    description: "Description",
    featurePending: "Feature under development",
    deleteConfirm: "Confirm delete selected task(s)?",
    deleteSuccess: "Deleted successfully",
    loadFail: "Failed to load tasks",
    actionFail: "Operation failed, please retry",
    copySuccess: "Copied successfully",
    statusUpdated: "Status updated",
    batchPublishReason: "Batch publish",
    batchPauseReason: "Batch pause",
    detailTitle: "Task Detail",
    proof: "Proof Requirements",
    proofLabel: "Field",
    proofField: "Field Key",
    proofType: "Type",
    required: "Required",
    requiredShort: "Req.",
    hint: "Hint",
    addProof: "Add Proof Item",
    moveUp: "Up",
    moveDown: "Down",
    uploadSuccess: "Image uploaded",
    uploadFail: "Image upload failed",
    meta: "Meta Info",
    metaDifficulty: "Difficulty",
    metaDuration: "Estimated Duration",
    metaReward: "Estimated Reward",
    metaTags: "Tags",
    steps: "Steps",
    createSuccess: "Created successfully",
    updateSuccess: "Updated successfully",
    unsavedConfirm: "You have unsaved changes, close anyway?",
    htmlSource: "HTML Source",
    stats: {
      total: "Total Tasks",
      active: "Active",
      draft: "Draft",
      today: "New Today",
    },
    listTitle: "Task List",
    maxAttempts: "Max Attempts",
    updatedAt: "Updated At",
  },
  taskReview: {
    title: "Task Submission Review",
    searchTitle: "Filter Submissions",
    submissionId: "Submission ID",
    submissionIdPlaceholder: "Enter submission ID",
    taskId: "Task ID",
    taskIdPlaceholder: "Enter task ID",
    search: "Search",
    reset: "Reset",
    userId: "User ID",
    userIdPlaceholder: "Enter user ID",
    reviewResult: "Review Result",
    reviewResultPlaceholder: "Select result",
    submittedRange: "Submitted Time",
    reviewedRange: "Reviewed Time",
    history: "Submission History",
    reviewClaimedAt: "Review Claimed At",
    assignmentInfo: "Assignment Info",
    claimedAt: "Claimed At",
    expiresAt: "Expires At",
    attemptCount: "Attempts",
    autoVerifyAt: "Auto Verify At",
    rewardLedgerId: "Reward Ledger ID",
    rejectionReason: "Rejection Reason",
    riskInfo: "Risk Info",
    ipAddress: "IP Address",
    deviceFingerprint: "Device Fingerprint",
    notes: "Notes",
    reviewer: "Reviewer",
    requirement: "Requirement",
    userSubmission: "User Submission",
    requirementExample: "Requirement",
    userSubmissionProof: "Submission",
    clickToCompare: "Click to compare",
    noSubmission: "No submission",
    expiresInDays: "Expires in {days} day(s)",
    expiresInHours: "Expires in {hours} hour(s)",
    expiresInMinutes: "Expires in {minutes} minute(s)",
    expired: "Expired",
    verificationMode: "Verification Mode",
    verificationModeMap: {
      auto: "Auto",
      manual: "Manual",
      callback: "Callback",
    },
    reviewResultMap: {
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
    },
    stats: {
      total: "Total",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
    },
    status: {
      unclaimed: "Unclaimed",
      mine: "My review",
      claimed: "Claimed",
      finished: "Completed",
    },
    passRate: "Pass",
    actions: "Actions",
    view: "View",
    reviewComment: "Comment",
    reviewCommentPlaceholder: "Enter comment (optional)",
    detailTitle: "Submission Detail",
    basicInfo: "Basic Info",
    proofCompare: "Proofs",
    submission: "Submission Proofs",
    value: "Value",
    takeReview: "Take Review",
    takeBtn: "Claim Task",
    takeSuccess: "Claimed successfully",
    claimNote: "No reviewer yet, click to claim this submission",
    claimedByOther: "Already claimed by {name}, waiting for review",
    reviewAction: "Review",
    isFinal: "Final Review",
    reviewSubmit: "Submit Review",
    saveDraft: "Save Draft",
    draftSaved: "Draft saved locally",
    quickTitle: "Quick tags",
    quick: {
      blur: "Image blurry",
      mismatch: "Content mismatch",
      missing: "Evidence missing",
      repeat: "Duplicated proof",
    },
    taskTitle: "Task Title",
    taskIntro: "Task Intro",
    taskSteps: "Task Steps",
    taskContext: "Task Context",
    proofRequirements: "Proof Requirements",
    submissionProofs: "Submitted Proofs",
    requirementHidden: "Requirements are hidden",
    showReq: "Show requirements",
    hideReq: "Hide requirements",
    expandIntro: "Expand",
    collapseIntro: "Collapse",
    user: "User",
    proof: "Proof Requirements",
    reviewInfo: "Review Info",
    reviewedBy: "Reviewed By",
    reviewedAt: "Reviewed At",
    submittedAt: "Submitted At",
    approveConfirm: "Confirm approve this submission?",
    rejectConfirm: "Please provide reject reason (optional)",
    reviewSuccess: "Review saved",
    batchApprove: "Batch Approve",
    batchReject: "Batch Reject",
    selectWarning: "Please select at least one submission",
    loadFail: "Failed to load submissions",
    detailFail: "Failed to load submission detail",
  },
  taskAssignment: {
    searchTitle: "Task Assignment",
    assignmentId: "Assignment ID",
    assignmentIdPlaceholder: "Enter assignment ID",
    taskId: "Task ID",
    taskIdPlaceholder: "Enter task ID",
    userId: "User ID",
    userIdPlaceholder: "Enter user ID",
    status: "Status",
    statusPlaceholder: "Select status",
    reviewerId: "Reviewer",
    reviewerIdPlaceholder: "Enter reviewer ID",
    myReview: "My Reviews",
    claimedRange: "Claimed Time",
    submittedRange: "Submitted Time",
    statusMap: {
      submitted: "Submitted",
      in_progress: "In Progress",
      approved: "Approved",
      rejected: "Rejected",
      expired: "Expired",
      cancelled: "Cancelled",
      unknown: "Unknown",
    },
    claimedAt: "Claimed At",
    submittedAt: "Submitted At",
    verifiedAt: "Verified At",
    reviewedAt: "Reviewed At",
    attemptCount: "Attempts",
    listTitle: "Task Assignment List",
  },
  tasks: {
    taskDetail: "Task Detail",
    description: "Description",
    steps: "Steps",
    submissionRequirements: "Submission Requirements",
    claimTask: "Claim Task",
    types: {
      video: "Watch Video",
      app_download: "Download App",
      social: "Social Engagement",
      referral: "Invite Friends",
      checkin: "Daily Check-in",
    },
    difficulty: {
      easy: "Easy",
      medium: "Medium",
      hard: "Hard",
    },
  },
};
